<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.ielts_detail") }}</h4>
          </div>
        </md-card-header>
        <md-card-content v-if="tableData.length">
          <chart
            :data-detail="dataDetail"
            v-if="dataDetail.chartData && tableData.length > 1"
          ></chart>
          <h3 class="text-xl font-medium text-center" v-else>
            {{ $t("smi_sri.hidden_chart") }}
          </h3>

          <h6 class="title text-md font-medium normal-case my-5">
            {{ $t("smi_sri.total_tests_taken", { length: tableData.length }) }}
          </h6>

          <md-table class="md-scrollbar table-assessment-detail">
            <md-table-row>
              <md-table-head rowspan="2">{{
                $t("smi_sri.test_name")
              }}</md-table-head>
              <md-table-head rowspan="2">Overall</md-table-head>
              <md-table-head rowspan="2">Test date W</md-table-head>
              <md-table-head rowspan="2">Listening</md-table-head>
              <md-table-head rowspan="2">Reading</md-table-head>
              <md-table-head colspan="3">Writing</md-table-head>
              <md-table-head colspan="6">Speaking</md-table-head>
              <md-table-head colspan="2">{{
                $t("smi_sri.comment")
              }}</md-table-head>
            </md-table-row>

            <md-table-row>
              <md-table-cell>
                <span class="w-max inline-block">Task 1</span>
              </md-table-cell>
              <md-table-cell>
                <span class="w-max inline-block">Task 2</span>
              </md-table-cell>
              <md-table-cell>
                <span class="w-max inline-block">Bandscore W</span>
              </md-table-cell>
              <md-table-cell>
                <span class="w-max inline-block">Test date S</span>
              </md-table-cell>
              <md-table-cell>GR</md-table-cell>
              <md-table-cell>LR</md-table-cell>
              <md-table-cell>FC</md-table-cell>
              <md-table-cell>P</md-table-cell>
              <md-table-cell>
                <span class="w-max inline-block">Bandscore S</span>
              </md-table-cell>
              <md-table-cell class="px-[150px]">Speaking</md-table-cell>
              <md-table-cell class="px-[150px]">Writing</md-table-cell>
            </md-table-row>

            <md-table-row
              v-for="(row, index) in tableData"
              :key="row.test_name + index"
            >
              <md-table-cell class="text-center">
                <span class="w-max inline-block">{{ row.test_name }}</span>
              </md-table-cell>
              <md-table-cell>
                {{ row.overall }}
              </md-table-cell>
              <md-table-cell>
                {{ convertDateFromServer(row.writing.test_date_w, "date") }}
              </md-table-cell>
              <md-table-cell>
                {{ row.writing.listening }}
              </md-table-cell>
              <md-table-cell>
                {{ row.writing.reading }}
              </md-table-cell>
              <md-table-cell>
                {{ row.writing["task 1"] }}
              </md-table-cell>
              <md-table-cell>
                {{ row.writing["task 2"] }}
              </md-table-cell>
              <md-table-cell>
                {{ row.writing.band_score_w }}
              </md-table-cell>
              <md-table-cell>
                {{ convertDateFromServer(row.speaking.test_date_s, "date") }}
              </md-table-cell>
              <md-table-cell>
                {{ row.speaking["GR"] }}
              </md-table-cell>
              <md-table-cell>
                {{ row.speaking["LR"] }}
              </md-table-cell>
              <md-table-cell>
                {{ row.speaking["FC"] }}
              </md-table-cell>
              <md-table-cell>
                {{ row.speaking["P"] }}
              </md-table-cell>
              <md-table-cell>
                {{ row.speaking.band_score_s }}
              </md-table-cell>
              <md-table-cell>
                {{ row.comment.speaking }}
              </md-table-cell>
              <md-table-cell>
                {{ row.comment.writing }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-content v-else>
          <no-data-found></no-data-found>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import Chart from "./Chart";
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  components: { Chart },
  props: ["dataDetail"],
  data() {
    return {
      convertDateFromServer
    };
  },
  computed: {
    tableData() {
      return this.dataDetail.ielts;
    }
  }
};
</script>
<style lang="scss">
.table-assessment-detail {
  th,
  td {
    border: 1px solid #dcdcdc;
    font-size: 14px;
  }

  .md-table-head {
    text-align: center !important;
  }
}
</style>
